import Dashboard from './component';

export default Dashboard;
